import { Inject, Injectable, Optional } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { isYattaExternalLinkUrl, OpenWindowProvider, YattaExternalLinkUrl } from '@platform-frontend/util';
import { LinkRenderer } from 'ngx-transloco-markup';
import { ExternalLinkRenderer } from './external-link-renderer';
import { LinkRendererService } from './link-renderer.service';

@Injectable()
export class DefaultLinkRenderer implements LinkRenderer<YattaExternalLinkUrl> {
  constructor(
    private linkRendererService: LinkRendererService,
    @Optional() @Inject(OpenWindowProvider) private openWindowProvider: string | null,
    private translocoService: TranslocoService
  ) {}

  supports(link: unknown): link is YattaExternalLinkUrl {
    // Override TranslocoMarkup default link renderer:
    return isYattaExternalLinkUrl(link);
  }

  render(link: YattaExternalLinkUrl, targetElement: HTMLAnchorElement): void {
    new ExternalLinkRenderer(this.linkRendererService, this.openWindowProvider, this.translocoService).render({ url: link }, targetElement);
  }
}
